
let DefaultMapStyle = {
    style : []
} 
export default DefaultMapStyle;